import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';

export const Error404 = () => {
  return (
    <Container className="text-center mt-5">
      <Row>
        <Col>
          <h1 className="display-1 text-danger">404</h1>
          <h2 className="mb-4">Page Not Found</h2>
          <p className="lead">
            Oops! The page you're looking for doesn't exist.
          </p>
          <Button as={Link as any} to="/" variant="primary">
            Go Back Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
